import { StyledProps } from 'styled-components';
import { COLOR_ACTIONABLE_LIGHT, COLOR_TABLE_HEADER_WEEKEND } from '../constants';

export const getColorForDay = (
    styledProps: StyledProps<{
        isWeekendDay: boolean;
        isCurrentTimeUnit: boolean;
    }>
): React.CSSProperties['backgroundColor'] => {
    if (styledProps.isWeekendDay) {
        return COLOR_TABLE_HEADER_WEEKEND;
    }

    if (styledProps.isCurrentTimeUnit) {
        return COLOR_ACTIONABLE_LIGHT;
    }

    return 'initial';
};
